import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Tab, Tabs, Form, Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faCircleXmark, faTrashCan, faPencil, faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Prev } from 'react-bootstrap/esm/PageItem';
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import ImageUpload from '../../../Components/common/ImageUpload.js';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDADDRESSSAVE, ULDSTATIONDETAILS, ULDADDRESSACTARC, ULDADDRESSRECMAIL, DELETERECEMAIL } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Trash from "../../../assets/images/trash.png";
import edit from "../../../assets/images/edit.png";
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import AgentDetails from './AgentDetails.js';

const AgentSettings = () => {
    const isMounted = useRef(false);
    const [selected, setSelected] = useState([]);

    const handleChange = (selected) => {
        setSelected(selected);
    };

    // +++++++++++++++++++++++++++++++ Multiselect dropdown

    const gridRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({ Active: {} })
        isMounted.current = true;
    }, []);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showDetails, setShowDetails] = useState(false);

    const [gridSelect, setGridSelect] = useState([]);

    const [formData, setFormData] = useState({
        port_Id: '',
        code: ''
    });

    const reloadGrid = () => {
        setIsLoading(false);
        setGridData({ Active: {} })
    };
    const handleDetailsBackClick = (rowData) => {
        // setSelectedRowData(rowData);
        setShowDetails(false);
        reloadGrid()
    };

    let checkUlds = [];
    let filterForCheck = false;

    useEffect(() => {

        if (gridRef.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            const source = {
                datatype: 'json',
                id: '1',
                datafields: [
                    { name: 'station_id', type: 'string' },
                    { name: 'station_code', type: 'string' },
                    { name: 'station_name', type: 'string' },
                    { name: 'agent_count', type: 'string' },
                ],
                url: `${process.env.REACT_APP_RFS_URL}handler-agent-settings/stations`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 10,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");

                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;

                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                { text: 'Station Code', filtertype: 'input', datafield: 'station_code', width: '15%', cellclassname: 'frcl', },
                { text: 'Station Name', filtertype: 'input', datafield: 'station_name', width: '60%', cellclassname: 'frcl', },
                { text: 'Agent Count', filtertype: 'input', datafield: 'agent_count', width: '15%', cellclassname: 'frcl', },
            ];

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                // selectionmode: 'checkbox',
                pageable: true,
                pageSize: 10,
                pagesizeoptions: ['10', '20', '50', '100'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).on('rowclick', (event) => {
                const args = event.args.row.bounddata;
                const sendRowId = gridData;
                setSelectedRowData(args);

                setShowDetails(true);
            });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            // row selection by checkbox
            window.$(gridRef.current).on('rowselect', (event) => {

                if (event.args.row) {
                    const selectedRow = event.args.row.id;
                    if (!gridSelect.includes(selectedRow)) {
                        setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
                    }
                    setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
                } else {
                    // Handle "Select All" case
                    // const allIds = planData.map(row => row.booking_id);
                    // console.log("All IDs:", allIds);
                    // setGridSelect(allIds);
                    console.log("Select All triggered");
                }
            });
            // console.log('ggg', gridSelect);
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
                } else {
                    setGridSelect([]);
                }
            });
            // End row selection 
        }
    }, [gridData]);

    return (
        <>
            <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                    {!showDetails &&
                        <>
                            <h4>Station Settings</h4>
                            <p>Set your notification preferences for when you are in or away from the dashboard.</p>
                            <div className='row'>
                                <div className='col-6'>
                                    <div className="station_grid">
                                        {!isLoading && <div ref={gridRef} className='staion_grid' ></div>}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {showDetails && (
                        <>
                            <button className='backbtn' onClick={handleDetailsBackClick}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
                            <AgentDetails stnData={selectedRowData} reload={reloadGrid} />
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default AgentSettings;